'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultipleCheckbox = function (_Component) {
    _inherits(MultipleCheckbox, _Component);

    function MultipleCheckbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MultipleCheckbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultipleCheckbox.__proto__ || Object.getPrototypeOf(MultipleCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this._onOptionSelect = function (data) {
            var newData = [].concat(_toConsumableArray(_this.props.value));

            for (var key in data) {
                // if we're "setting" the value...
                if (data[key] === true) {
                    // if it doesn't exist already, add it in
                    if (newData.indexOf(key) === -1) {
                        newData.push(key);
                    }
                } else {
                    // we're "unsetting" the value...
                    var index = newData.indexOf(key);

                    // if the item does exist, remove it
                    if (index !== -1) {
                        newData.splice(index, 1);
                    }
                }
            }

            _this.props.updateValue(_defineProperty({}, _this.props.name, newData));
        }, _this._optionSelected = function (value) {
            return _this.props.value.some(function (item) {
                return item === value;
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MultipleCheckbox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            });

            var columnisedOptionsList = [];

            var optionList = [];

            if (this.props.options) {
                optionList = this.props.options.map(function (option) {
                    return _react2.default.createElement(_Checkbox2.default, {
                        disabled: _this2.props.disabled,
                        key: option.value,
                        label: option.label,
                        name: option.value,
                        updateValue: _this2._onOptionSelect,
                        value: _this2._optionSelected(option.value)
                    });
                });
            }

            if (this.props.columns > 1) {
                var minPerColumn = Math.floor(optionList.length / this.props.columns);
                var remainder = optionList.length % this.props.columns;
                var extra = 0;

                for (var i = 0; i < this.props.columns; i++) {
                    var columnExtra = i < remainder ? 1 : 0;

                    columnisedOptionsList.push(optionList.slice(i * minPerColumn + extra, (i + 1) * minPerColumn + extra + columnExtra));

                    extra += columnExtra;
                }
            } else {
                columnisedOptionsList.push(optionList);
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    null,
                    this.props.label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form__control' },
                    _react2.default.createElement(
                        'table',
                        { width: '100%' },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                columnisedOptionsList.map(function (column, index) {
                                    return _react2.default.createElement(
                                        'td',
                                        { key: index },
                                        column
                                    );
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors })
            );
        }
    }]);

    return MultipleCheckbox;
}(_react.Component);

MultipleCheckbox.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.hasOptionsPropTypes, {

    columns: _propTypes2.default.number
});
MultipleCheckbox.defaultProps = {
    columns: 1,
    disabled: false
};
exports.default = MultipleCheckbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@matyas/matyaskar-forked-react-ui/lib/MultipleCheckbox.js
// module id = 394
// module chunks = 0